// src/pages/project/settings/ProjectMembersPage.tsx
import React from 'react';
import { useParams } from 'react-router-dom';
import MembersTab from '../../../features/projects/MembersTab';

const ProjectMembersPage: React.FC = () => {
  const { projectId = '' } = useParams<{ projectId: string }>();

  if (!projectId) {
    return <div className="p-6 text-sm text-red-600">projectId 가 없습니다.</div>;
  }

  return (
    <div className="p-6 space-y-4">
      <h1 className="text-lg font-semibold mb-2">프로젝트 멤버</h1>
      <p className="text-xs text-gray-500 mb-4">
        이 프로젝트에 참여하는 사용자와 역할(Project Role)을 관리합니다.
      </p>

      <MembersTab projectId={projectId} />
    </div>
  );
};

export default ProjectMembersPage;
